import {ThresholdsComponent} from './thresholds.component';
import {ThresholdsListComponent} from './thresholds-list/thresholds-list.component';
import {ThresholdsConfigurationComponent} from './thresholds-configuration/thresholds-configuration.component';
import {ThresholdsResolver} from './thresholds-resolver';
import {NgModule} from '@angular/core';
import {MaterialModule} from '../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {CommonModule} from '@angular/common';
import {HighchartModule} from '../../utils/highchart/highchart.module';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';

@NgModule({
    declarations: [
        ThresholdsComponent,
        ThresholdsListComponent,
        ThresholdsConfigurationComponent
    ],
  imports: [
    MaterialModule,
    FormsModule,
    ArmFormTitleModule,
    LayoutModule,
    CommonModule,
    ReactiveFormsModule,
    HighchartModule,
    ArmFormModule,
    ActionBarModule
  ],
    providers: [
        ThresholdsResolver
    ]
})
export class ThresholdsModule {
}
